// AuthProvider.js
import React, { createContext, useState, useEffect } from 'react';
import { useCheckAuthStatus, useLoginMutation } from '../../hooks/auth/Users';
import { useGetCurrentVendor, useGetVendorId } from '../../hooks/global/User';
import { useGetVendor } from '../../hooks/vendors/Vendors';
import { useLocation, useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const vendorId = useGetVendorId();
    const location = useLocation();
    const navigate = useNavigate();

    const [ID, setID] = useState(vendorId);

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const persistedAuthState = localStorage.getItem('isAuthenticated') === 'true';
        return persistedAuthState; 
    });

    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const [authError, setAuthError] = useState(null);

    const {data:vendorData, refetch} = useGetVendor();

    const {data:status} = useCheckAuthStatus();

    useEffect(() => {
        if (status) {
            setIsAuthenticated(status.isAuthenticated);
        }
    }, [status]);

    const loginAction = useLoginMutation(setIsAuthenticated, setAuthError);

    const login = async (username, password) => {
        const data = await loginAction.mutate(username, password);
    }

    const logout = async () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('vendorId');
        localStorage.removeItem('vendor');
        localStorage.removeItem('admin');
        setIsAuthenticated(false);
        setAuthError(null);
    };

    const switchVendor = async (id) => {
        setID(id);
        localStorage.setItem('vendorId', id);
        navigate(location.pathname.includes("/vendors") ? location.pathname.replace(/\/vendors\/[^\/]+/, `/vendors/${id}`) : `/admin/vendors/${id}/dashboard`);
        window.location.reload();
    }


    return (
        <AuthContext.Provider value={{ isAuthenticated, isAuthenticating, authError, setIsAuthenticated,  login, logout, switchVendor }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
